import { useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import '../App.css';
import RecentPost from "../RecentPost";
import ContactNumber from "../ContactNumber";
import { Helmet } from "react-helmet";

export default function Luxurypginkharadi(){
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
    
    const faqs = [
      {
        question: "What types of rooms are available at Om Sai Luxury PG?",
        answer: "Om Sai Luxury PG offers spacious and beautifully furnished single, double, and triple-sharing rooms. All rooms are equipped with premium furniture, comfortable beds, air conditioning (in select rooms), and high-end amenities."
      },
      {
        question: "Are meals included in the rent?",
        answer: "Yes, meals are included in the rent. We provide gourmet home-cooked meals with both vegetarian and non-vegetarian options. The meals are freshly prepared and cater to various dietary preferences."
      },
      {
        question: "How much does the rent cost at Om Sai Luxury PG?",
        answer: "The rent for Om Sai Luxury PG is competitive for its premium offerings. Rent varies based on room type and sharing arrangements. The rent includes all amenities like meals, Wi-Fi, housekeeping, and utilities."
      },
      {
        question: "Is there Wi-Fi available in the PG?",
        answer: "Yes, high-speed Wi-Fi is available throughout the premises, ensuring seamless connectivity for work, study, and entertainment."
      },
      {
        question: "How secure is Om Sai Luxury PG?",
        answer: "Om Sai Luxury PG ensures the safety of its residents with 24/7 security, CCTV surveillance, and controlled access. We prioritize your safety and provide a secure living environment."
      },
      {
        question: "Are laundry and housekeeping services available?",
        answer: "Yes, we offer daily housekeeping and laundry services to ensure your living space is always clean and fresh. We take care of your cleaning needs so you can focus on other priorities."
      },
      {
        question: "What kind of facilities are available in the common areas?",
        answer: "Om Sai Luxury PG offers spacious common areas, including lounges, a recreational area, and a gym. These spaces are designed to provide relaxation, socializing opportunities, and wellness activities for residents."
      },
      {
        question: "Is there parking available at Om Sai Luxury PG?",
        answer: "Yes, Om Sai Luxury PG provides parking space for residents with vehicles. We ensure the safety and security of your vehicle while it’s parked at the premises."
      },
      {
        question: "Can I customize my meal preferences?",
        answer: "Yes, we strive to accommodate specific dietary requirements or preferences. If you have any special meal requests, feel free to inform our management, and we will do our best to meet your needs."
      },
      {
        question: "Is Om Sai Luxury PG suitable for both students and professionals?",
        answer: "Yes, Om Sai Luxury PG is suitable for both students and working professionals. The luxury facilities and premium services make it ideal for individuals who value comfort and convenience during their stay."
      }
    ];
    
    const testimonials = [
      {
        quote: "I’ve been staying at this luxury PG in Kharadi for the last 6 months, and I can honestly say it’s been an exceptional experience. The rooms are spacious, elegantly furnished, and equipped with top-notch amenities like air conditioning, high-speed Wi-Fi, and premium bedding. The food is gourmet quality, with a variety of options to suit different tastes. The common areas, including the lounge and study spaces, are modern and well-maintained. The location is perfect for both work and leisure, with easy access to major business hubs and shopping centers. If you’re looking for a comfortable, high-end PG, this is the place!",
        author: "- Anjali Mehta"
      },
      {
        quote: "This luxury PG in Kharadi exceeded all my expectations. The attention to detail in every aspect of the accommodation is remarkable. The rooms are stylish and have all the modern conveniences you could ask for, including a smart TV and personal refrigerator. The food is of the highest quality, with both healthy and indulgent options. The facilities, such as the gym and spa, make it a perfect place for relaxation after a long workday. The staff is courteous and professional, ensuring a seamless stay. It truly feels like a home away from home, with all the comforts of luxury!",
        author: "- Rohit Kapoor"
      }
    ];
    
      
      const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
      };
    
    
    
    
    return(
        <>

<Helmet>
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Om Sai PG",
      "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
      "url": "https://www.omsaipg.in/Luxury-PG-in-Kharadi",
      "logo": "https://www.omsaipg.in/images/logo.jpg",
      "image": "https://www.omsaipg.in/images/img/keyword-image/Luxury-pg-pune-om-sai-pg.jpg",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+91 9763888448",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
        {
          "@type": "ContactPoint",
          "telephone": "+91 9922248255",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "bestRating": "5",
        "worstRating": "1",
        "ratingValue": "4.7",
        "ratingCount": "250",
      },
      "email": "omsaipg@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
        "addressLocality": "Kharadi",
        "addressRegion": "Maharashtra",
        "postalCode": "411014",
        "addressCountry": "IN",
      },
      "sameAs": [
        "https://www.facebook.com/omsaipg",
        "https://www.instagram.com/omsaipg",
        "https://www.linkedin.com/company/omsaipg"
      ],
      "priceRange": "INR 8,500-6000",
      "paymentAccepted": "Cash, UPI, Credit Card",
      "telephone": "+91 9763888448",
      "email": "omsaipgpune@gmail.com",
      "keywords": [
        "Luxury PG in Kharadi",
        "PG with food in Kharadi",
        "Paying Guest in Kharadi",
        "Hostels near Kharadi IT Park",
        "PG for students in Kharadi"
      ],
      "openingHours": "Mo-Su 09:00-22:00"
    })}
  </script>

  {/* Title */}
  <title>Om Sai PG | Luxury PG in Kharadi | Paying Guest Near Kharadi IT Park</title>

  {/* Meta Tags */}
  <meta
    name="description"
    content="Om Sai PG offers the best luxury PG accommodations in Kharadi, Pune, with food included. Perfect for students and professionals near Eon IT Park."
  />
  <meta
    name="keywords"
    content="Luxury PG in Kharadi, PG with food in Kharadi, Paying Guest in Kharadi, Hostels near Kharadi IT Park, PG for students in Kharadi"
  />
  <meta name="robots" content="index, follow" />

  {/* Open Graph Tags */}
  <meta
    property="og:title"
    content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
  />
  <meta
    property="og:description"
    content="Looking for luxury PG accommodation near Kharadi IT Park in Pune? Om Sai PG offers premium PGs with food and all essential amenities for students and professionals."
  />
  <meta property="og:image" content="https://www.omsaipg.in/img/keyword-image/Luxury-pg-pune-om-sai-pg.jpg" />
  <meta property="og:url" content="https://www.omsaipg.in/Luxury-PG-in-Kharadi" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Om Sai PG" />
</Helmet>


     <section class="section-breadcrumb padding-b-50">
        <div class="rx-breadcrumb-image bg-img">
            <div class="rx-breadcrumb-overlay"></div>
            <div class="inner-breadcrumb-contact">
                <div class="main-breadcrumb-contact">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="rx-banner-contact">
                                    <h2>Luxury PG in Kharadi </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rx-banner-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="breadcrumb-contact">
                                    <div class="main-heading">
                                        <h4>Luxury PG in Kharadi </h4>
                                    </div>
                                    <div class="last-contact">
                                        <ul>
                                            <li>
                                                <Link to="/">Home</Link>
                                            </li>
                                            <li>Luxury PG in Kharadi</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

      {/* <!-- Page Banner End --> */}

      <div class="section-about padding-tb-50 keywordsection">
        <div className="container">
          <div className="row d-flex justify-content-around">
            <div className="col-12 col-md-8">
              <div className="keyword-img">
                <img src="img/keyword-image/Luxury-pg-pune-om-sai-pg.jpg" className="img-fluid" alt="Luxury-pg-pune-om-sai-pg" />
              </div>
              <h2>Luxury PG in Kharadi, Pune – Om Sai PG: The Ultimate Comfort for Professionals and Students</h2>

<p>Look no further than Om Sai PG, a premier PG accommodation designed for those who desire a high standard of living without compromising on comfort, convenience, and security. Located in the heart of Kharadi, one of Pune’s fastest-growing neighborhoods, Om Sai PG is the ideal choice for professionals and students seeking top-tier amenities and an upscale living experience.</p>

<h3>Why Choose Om Sai Luxury PG in Kharadi?</h3>
<p>Kharadi is home to several key business hubs and educational institutions, making it a prime location for both working professionals and students. Om Sai PG offers luxury living with a focus on comfort, safety, and convenience. Whether you are new to the city or just looking to upgrade your living situation, Om Sai PG promises a high-quality living experience that meets all your needs.</p>

<h3>Premium Facilities at Om Sai Luxury PG in Kharadi</h3>
<p>At Om Sai PG, we offer a host of luxury amenities that ensure your stay is as comfortable and hassle-free as possible. Here’s what sets us apart from the rest:</p>

<h4>1. Elegant and Fully Furnished Rooms</h4>
<p>Each room at Om Sai PG is tastefully furnished to create a serene and comfortable living environment. Enjoy the luxury of comfortable beds, spacious wardrobes, study tables, and stylish furniture that makes your stay a pleasant experience.</p>

<h4>2. High-Speed Wi-Fi</h4>
<p>Stay connected at all times with high-speed Wi-Fi that supports your work, studies, or entertainment needs. Whether you are working from home, attending online meetings, or streaming content, the internet speed is fast and reliable.</p>

<h4>3. Gourmet Meals with Breakfast and Dinner</h4>
<p>Experience delicious, home-cooked meals at Om Sai PG. We offer gourmet-quality breakfast and dinner that cater to your taste and nutritional needs. Enjoy freshly prepared meals every day that will keep you energized and satisfied.</p>

<h4>4. 24/7 Hot Water and Water Supply</h4>
<p>At Om Sai PG, you’ll never have to worry about hot water or water availability. We provide 24/7 hot water and continuous water supply so that you can enjoy the utmost comfort throughout the day.</p>

<h4>5. Housekeeping Services</h4>
<p>Our premium housekeeping services ensure that your room is always neat, tidy, and organized. You can focus on your work and studies without worrying about cleaning or maintaining your living space.</p>

<h4>6. CCTV Surveillance and 24/7 Security</h4>
<p>Your safety is our priority. Om Sai PG is equipped with CCTV cameras for 24/7 surveillance. We also have round-the-clock security staff, ensuring that your stay is safe and secure at all times.</p>

<h4>7. Complimentary Electricity Bills</h4>
<p>Om Sai PG believes in providing an all-inclusive package, so your electricity bills are covered in the rent. No hidden charges, just a transparent and hassle-free living experience.</p>

<h4>8. Fridge, Gas, and Kitchenette Facilities</h4>
<p>For those who prefer to prepare meals or store snacks, we provide a shared fridge, gas facility, and a kitchenette for your convenience. While the PG meals are delicious, having the option to prepare your own food adds extra comfort.</p>

<h4>9. Secure 2-Wheeler Parking</h4>
<p>For professionals and students who commute by bike or scooter, Om Sai PG provides secure 2-wheeler parking. This feature ensures that your vehicle is always safe and easily accessible.</p>

<h4>10. Purified Drinking Water</h4>
<p>We care about your health, which is why we provide purified drinking water to ensure that you always have access to clean and safe water.</p>

<h3>Affordable Luxury Packages for Om Sai PG in Kharadi</h3>
<p>Despite the luxury facilities, Om Sai PG remains highly affordable, providing value for money with all-inclusive amenities. Here’s a breakdown of the pricing:</p>
<ul>
    <li><strong>Single Sharing Room:</strong> ₹8,500 per month (including breakfast and dinner)</li>
    <li><strong>Double Sharing Room:</strong> ₹7,000 per month (including breakfast and dinner)</li>
    <li><strong>Triple Sharing Room:</strong> ₹6,000 per month (including breakfast and dinner)</li>
</ul>
<p>A deposit of ₹3,000 is required at the time of booking, along with one month’s advance rent.</p>

<h3>Ideal Location for Luxury Living</h3>
<p>Om Sai PG is ideally located in Kharadi, one of Pune's most upscale and well-connected neighborhoods. The area is home to Eon IT Park and other top business hubs, making it the perfect location for professionals working in the IT and corporate sectors. Additionally, it is well-connected by public transport, making commuting to different parts of Pune quick and convenient.</p>

<h3>How to Book a Room at Om Sai Luxury PG?</h3>
<p>Booking your stay at Om Sai PG is easy. Simply get in touch with us through the following contact methods:</p>
<ul>
    <li><strong>Phone:</strong> 9763888448 | 9922248255</li>
    <li>Alternatively, you can visit us in person to take a tour of the PG and see the rooms before making your reservation.</li>
</ul>

<h3>Contact Information for Om Sai Luxury PG</h3>
<ul>
    <li><strong>Phone:</strong> 9763888448 | 9922248255</li>
</ul>


<h2>Luxury PG Near Kharadi</h2>

<p>Kharadi offers a variety of luxury PGs with premium amenities for professionals and students who want a comfortable living experience. These luxury PGs near Kharadi feature spacious rooms, modern furniture, 24/7 security, high-speed internet, and other amenities like air conditioning, gym access, and home-cooked meals. Whether you're working at an IT park or studying, these PGs offer a stylish, comfortable, and secure environment for all your needs.</p>

<h2>Luxury Ladies PG Near Me</h2>

<p>If you're searching for a luxury ladies PG near me, you'll find numerous options that provide a high standard of living. Luxury PGs for ladies offer exclusive and secure accommodations with services like nutritious meals, Wi-Fi, laundry, housekeeping, and 24/7 security. Whether you’re a working professional or a student, these PGs are designed to cater to the specific needs of women, offering both comfort and privacy.</p>

<h2>Luxury PGs Near Me</h2>

<p>Whether you're working or studying in Pune, luxury PGs provide top-notch facilities such as high-speed internet, air-conditioned rooms, nutritious meals, housekeeping, and more. These PGs are located near prime areas like Kharadi, Hinjewadi, and Koregaon Park, making them perfect for people seeking comfort, privacy, and convenience. Luxury PGs near you offer the best amenities for a homely stay.</p>

<h2>Luxury Paying Guest</h2>

<p>A luxury paying guest accommodation offers a premium living experience with all the modern amenities you need, including private rooms, meals, high-speed Wi-Fi, and security. These PGs are ideal for professionals and students who seek a balance of comfort and luxury. Whether it's a single room or a shared space, luxury PGs provide a secure, comfortable, and convenient living environment.</p>

<h2>Modern Deluxe PG for Ladies</h2>

<p>A deluxe PG for ladies provides the ultimate in comfort and security. These PGs offer modern interiors, Wi-Fi, nutritious meals, laundry, and 24/7 security. Designed to cater to the needs of working women and students, deluxe PGs for ladies offer a homely, private, and peaceful environment. These PGs are well-located and provide easy access to workplaces, educational institutions, and public transport.</p>

<h2>Luxury Paying Guest in Kharadi</h2>

<p>If you need a luxury paying guest in Kharadi, you’ll find several premium accommodations that offer top-tier facilities. These luxury PGs in Kharadi include spacious, air-conditioned rooms, high-speed internet, food services, and secure living spaces. Located near IT parks, shopping areas, and transport links, these PGs are ideal for professionals and students who want to stay in a comfortable and convenient location while enjoying the best amenities.</p>

<h2>Affordable PG in Kharadi Pune</h2>

<p>Kharadi offers a variety of budget-friendly PGs that provide comfortable living spaces without compromising on essential amenities. These affordable PGs include services such as food, Wi-Fi, and security, while ensuring the rent is reasonable. Whether you're a student or a professional, PGs in Kharadi offer the perfect balance of affordability and convenience, making it an ideal choice for anyone looking for value for money.</p>

<h2>PG with Laundry Facility Kharadi</h2>

<p>If you're looking for a PG with laundry facility in Kharadi, there are plenty of options available. These PGs offer laundry services along with other amenities like food, Wi-Fi, and 24/7 security. PGs with laundry facilities in Kharadi are ideal for working professionals and students who want to focus on their work or studies without the hassle of managing laundry. The added convenience of laundry services makes these PGs a great choice for hassle-free living.</p>

<h2>PG with TV in Kharadi</h2>

<p>Many PGs in Kharadi are equipped with televisions in common areas or individual rooms, providing entertainment and a homely atmosphere. These PGs also offer other amenities such as high-speed internet, nutritious meals, and 24/7 security. PGs with TV in Kharadi offer a comfortable and convenient stay for students and professionals who wish to relax and unwind after a busy day.</p>

<h2>Kharadi PG with WiFi</h2>

<p>Kharadi offers several PG accommodations with high-speed internet to cater to the needs of students and professionals. Whether you need WiFi for work, studies, or leisure, PGs in Kharadi with WiFi ensure you stay connected. These PGs come with additional amenities like food services, security, and laundry, making them the ideal choice for a comfortable living experience.</p>

<h2>PG with Power Backup in Kharadi Pune</h2>

<p>If you're looking for a PG with power backup in Kharadi Pune, many PGs in this area offer uninterrupted power supply through generators or inverters. This ensures you won’t face any inconvenience during power outages, especially important for professionals working from home or students preparing for exams. PGs with power backup in Kharadi provide a seamless living experience, making it easier for you to stay focused without worrying about power disruptions.</p>

<h2>PG with Refrigerator Kharadi</h2>

<p>Several PGs in Kharadi are equipped with refrigerators for the convenience of students and working professionals. A PG with refrigerator allows you to store your food and beverages, offering greater flexibility and convenience. Along with a fridge, these PGs often offer other amenities like Wi-Fi, meals, laundry, and 24/7 security, making them a great choice for a comfortable stay.</p>

<h2>Furnished PG in Kharadi Pune</h2>

<p>Kharadi offers well-furnished PGs that are ready to move in. These PGs come with modern furniture, comfortable bedding, study tables, and other necessary amenities like Wi-Fi, food, and security. Whether you need a private room or a shared one, furnished PGs in Kharadi Pune provide everything you need for a comfortable and convenient stay.</p>




            <h2>Om Sai PG for "Single Room PG in Pune" Contact Number:- </h2>
            <p>Contact Om Sai PG at +91 9763888448 / +91 9922248255. Our PG is strategically located in the heart of Kharadi, one of Pune's most vibrant and accessible neighborhoods, making it an ideal choice for students and professionals alike.</p>

            
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  borderWidth: "0px",
                }}
                border="1"
              >
                <colgroup>
                  <col style={{ width: "49.9491%" }} />
                  <col style={{ width: "49.9491%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td style={{ borderWidth: "0px" }}>
                    <p> - Luxury PG Near Kharadi</p>
<p> - Luxury Ladies PG Near Me</p>
<p> - Luxury PGs Near Me</p>
<p> - Luxury Paying Guest</p>
<p> - Modern Deluxe PG for Ladies</p>
<p> - Luxury Paying Guest in Kharadi</p>
                    </td>
                    <td style={{ borderWidth: "0px" }}>
                    <p> - Affordable PG in Kharadi Pune</p>
<p> - PG with Laundry Facility Kharadi</p>
<p> - PG with TV in Kharadi</p>
<p> - Kharadi PG with WiFi</p>
<p> - PG with Power Backup in Kharadi Pune</p>
<p> - PG with Refrigerator Kharadi</p>
<p> - Furnished PG in Kharadi Pune</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              
              <h2>Why Choose Om Sai Luxury PG in Kharadi, Pune?</h2>

<ul>
  <li><strong>Premium Location in Kharadi</strong><br/>Om Sai Luxury PG is located in the highly sought-after Kharadi area, one of Pune’s prime locations. The area is home to prestigious educational institutions, corporate offices, and IT parks, making it an ideal spot for professionals and students. It also offers easy access to public transport, shopping malls, restaurants, and recreational facilities.</li>
  <li><strong>Luxurious, Fully Furnished Rooms</strong><br/>Our PG offers luxurious, spacious, and fully furnished rooms designed for comfort and style. Each room is equipped with high-quality furniture, including comfortable beds, study tables, ergonomic chairs, wardrobes, air conditioning (in select rooms), and flat-screen TVs to ensure a relaxed living experience.</li>
  <li><strong>High-End Amenities and Facilities</strong><br/>Om Sai Luxury PG is equipped with premium amenities, including air conditioning, high-speed Wi-Fi, premium bedding, and modern bathrooms with hot water. We also provide housekeeping services, ensuring your space is always clean and fresh.</li>
  <li><strong>Gourmet Dining with Fine Cuisine</strong><br/>At Om Sai Luxury PG, we offer an exquisite dining experience. Enjoy gourmet meals prepared by professional chefs that cater to both vegetarian and non-vegetarian preferences. The meals are freshly prepared, hygienic, and designed to be nutritious, providing a five-star dining experience at your doorstep.</li>
  <li><strong>High-Speed Wi-Fi and Advanced Technology</strong><br/>Stay connected with our high-speed Wi-Fi available throughout the premises. Whether you're working, studying, or streaming, the internet speed ensures uninterrupted access. We also offer smart features in rooms, such as advanced lighting and air conditioning control systems, ensuring maximum comfort.</li>
  <li><strong>24/7 Security with Surveillance</strong><br/>We prioritize your safety and peace of mind. Om Sai Luxury PG is equipped with 24/7 security personnel, CCTV surveillance, and controlled access to ensure that you feel safe at all times.</li>
  <li><strong>Spa-Like Bathrooms with Premium Fixtures</strong><br/>Our luxury PG includes modern, spa-like bathrooms with premium fixtures and fittings. You’ll enjoy clean, comfortable, and well-maintained washrooms with hot water supply available 24/7.</li>
  <li><strong>Spacious and Elegant Common Areas</strong><br/>Our luxury PG offers large, beautifully designed common areas where residents can unwind and socialize. These spaces include lounges, recreational areas, and a well-equipped gym, providing a perfect blend of relaxation and wellness for residents.</li>
  <li><strong>Personalized Concierge Services</strong><br/>To further elevate your stay, Om Sai Luxury PG provides personalized concierge services. Whether it's arranging transportation, booking appointments, or organizing special requests, our team is ready to cater to your needs, ensuring a luxurious and hassle-free experience.</li>
  <li><strong>Professional and Friendly Staff</strong><br/>Our professional, friendly, and responsive staff is always available to assist with any requirements or issues you may have. We aim to provide you with a seamless and luxury experience throughout your stay.</li>
</ul>
              <div className="">
                  <h2>
                  FAQs for Om Sai Luxury PG in Kharadi, Pune ? 
                  </h2>
                  {faqs.map((faq, index) => (
                    <div key={index} className="faq-item">
                      <div
                        className={`faq-question ${
                          activeIndex === index ? "active" : ""
                        }`}
                        onClick={() => toggleAccordion(index)}
                      >
                        {index + 1}. {faq.question}
                      </div>
                      {activeIndex === index && (
                        <div className="faq-answer">{faq.answer}</div>
                      )}
                    </div>
                  ))}
                </div>


                  {/* ======================== */}
                  <div className="container">
                    <div className="testimonial-section">
                  <h2>
                  Testimonials for a luxury PG in Kharadi, Pune :-  {" "}
                  </h2>
                  <Slider {...settings}>
                    {testimonials.map((testimonial, index) => (
                      <div key={index} className="testimonial-slide">
                        <blockquote>
                          <p>{testimonial.quote}</p>
                          <footer>— {testimonial.author}</footer>
                        </blockquote>
                      </div>
                    ))}
                  </Slider>
                  </div>
                </div>

                {/* ================= */}
                <ContactNumber></ContactNumber>
            </div>
           <RecentPost></RecentPost>
        
        </div>
        </div>
      </div>
    </>
  );
}
